import { useContext, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import LoadingComponent from "../../components/loading";
import { ToastErro } from "../../components/toast";
import UserContext from "../../context/user/UserContext";
import { MeService } from "../../services/auth";
// import { MeService } from "../../services/auth";

const AuthMiddleware = () => {

    const { user, setUser, setRoles } = useContext(UserContext);

    const navigate = useNavigate();

    // verificar usuário logado
    const checkUserLogged = async () => {    
        await MeService().then((resp: any) => {
            setUser(resp.data.user);
            setRoles(resp.data.roles);
        }).catch((err) => {
            ToastErro('Faça login para acessar!');
            navigate('/');
        });
    }
    // verificar usuário logado

    useEffect(() => {
        if(user === null)
        {
            checkUserLogged();
        }
    }, []);

    if(user === null)
    {
        return (
            <div style={{ justifyContent: 'center', alignItems: 'center', marginTop: '25%' }}>
                <LoadingComponent />
            </div>
        )
    }else
    {
        return <Outlet />
    }

}

export default AuthMiddleware;